import { apiClient, bearer, unwrap } from './client';
import type { components } from './types';

export type ClaimedLineOut = components['schemas']['ClaimedLineOut'];
export type TransactionClaimsOut = components['schemas']['TransactionClaimsOut'];
export type ClaimedLinesOut = components['schemas']['ClaimedLinesOut'];

/** Batched filed-claim lookup for a page of transactions — deterministic
 *  joins only, keyed by external transaction id (`period_count === 0`
 *  means the customer has no claim data loaded). */
export function listClaimedLines(
  slug: string,
  transactionIds: string[],
  idToken: string,
): Promise<ClaimedLinesOut> {
  return apiClient
    .GET('/api/customers/{slug}/claimed-lines', {
      params: {
        path: { slug },
        query: { transaction_ids: transactionIds },
      },
      headers: bearer(idToken),
    })
    .then(unwrap<ClaimedLinesOut>);
}
